import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Building2, TrendingUp, Users } from 'lucide-react';
export function WhoWeWorkWith() {
  const clients = [{
    icon: Globe,
    text: 'Global and Nordic enterprises'
  }, {
    icon: Building2,
    text: 'Public sector and municipalities'
  }, {
    icon: TrendingUp,
    text: 'Growth companies scaling culture and leadership'
  }, {
    icon: Users,
    text: 'Industry events, retreats, and learning forums'
  }];
  return <section className="py-24 bg-navy-700 text-white" data-id="element-146">
      <div className="max-w-7xl mx-auto px-6" data-id="element-147">
        <div className="text-center mb-16" data-id="element-148">
          <h2 className="text-3xl md:text-4xl font-heading text-white mb-6" data-id="element-149">
            Who We Work With
          </h2>
          <p className="text-lg text-white/80 max-w-2xl mx-auto" data-id="element-150">
            We serve organisations who don't just want a speaker – but the right
            voice at the right moment for the right shift.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-151">
          {clients.map((client, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-800/50 p-6 rounded-xl border border-white/10 hover:border-gold-500/50 transition-colors" data-id="element-152">
              <div className="w-12 h-12 bg-white/10 rounded-lg flex items-center justify-center mb-4 text-gold-400" data-id="element-153">
                <client.icon size={24} data-id="element-154" />
              </div>
              <p className="font-medium text-lg leading-snug" data-id="element-155">{client.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}